import PersonFill from './PersonFill';

export default PersonFill;
